import { GridItem, LayoutGrid, TypographyV3 } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

const MABHero = (): JSX.Element => {
  const t = useTranslations();
  return (
    <section
      className="bg-sandstone-200 pt-36 pb-16 text-sandstone-500 md:pt-32 lg:px-5"
      data-cy="MAB-hero"
    >
      <LayoutGrid className="content-between">
        <GridItem
          colStart={{ sm: 'main', md: 5 }}
          colEnd={{ sm: 'main', md: 16 }}
        >
          <TypographyV3
            Element="h1"
            variant="h1"
            color="inherit"
            data-cy="MAB-hero-heading"
          >
            {t('mab_hero_heading')}
          </TypographyV3>
        </GridItem>
        <GridItem
          colStart={{ sm: 'main', md: 9 }}
          colEnd={{ sm: 'main', md: 19 }}
        >
          <TypographyV3
            Element="p"
            variant="h6"
            color="inherit"
            data-cy="MAB-hero-copy"
          >
            {t('mab_hero_copy')}
          </TypographyV3>
        </GridItem>
      </LayoutGrid>
    </section>
  );
};

export default MABHero;
